import Vue from 'vue';
import Router from 'vue-router';
import login from './views/login.vue';
import stage from './views/stage.vue';
import noController from '@/components/noController.vue';
import qa from './components/qa.vue';

Vue.use(Router);

export default new Router({
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'login',
        component: login
    }, {
        path: '/index.html',
        name: 'login',
        component: login
    }, {
        path: '/stage',
        name: 'stage',
        component: stage
    }, {
        path: '/stage/:from',
        component: stage
    }, {
        path: '/noController',
        name: 'noController',
        component: noController
    }, {
        path: '/qa',
        name: 'qa',
        component: qa
    }]
});
